/** So'rov 2 daqiqadan uzoq ketsa — bu javob emas, osilib qolish. */
export const REQUEST_TIMEOUT = 120_000;

/** Bir xil xato xabari shu vaqt ichida ikkinchi marta ko'rsatilmaydi. */
export const ERROR_TOAST_DEDUPE_MS = 3_000;
